import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { compose } from '@grandvisionhq/utils';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import { withAnchor } from '../../hocs/with-anchor.js';
import { useBloomreach } from '../../context/context.js';

const CustomPackage = ({ meta  })=>{
    const { customComponentMap  } = useBloomreach();
    const element = customComponentMap && customComponentMap[meta.packageId];
    if (!element) {
        return /*#__PURE__*/ React.createElement("div", null, `No component found for Custom Package ID: "${meta.packageId}"`);
    }
    return /*#__PURE__*/ React.createElement(element.type, swcHelpers.objectSpread({}, element.props));
};
var CmsCustomPackage = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CustomPackage);

export { CustomPackage, CmsCustomPackage as default };
//# sourceMappingURL=CustomPackage.js.map
